export const ImageUrl = (path, width = 100, height=100, action='c2') => {
    if (!path) {
        return '';
    }
    if (!width) {
        // width = 100;
    }
    if (!height) {
        // height = 100;
    }
    if (!action) {
        // action = 'crop2';
    }
    switch (action) {
        case 'full':
            return 'https://cdn1.shooq.co.il/data/full/' + path;
        case 'c':
        case 'crop':
            return 'https://cdn1.shooq.co.il/data/crop/n/' + width + '/' + height + '/' + path;
        case 'c2':
        case 'crop2':
            return 'https://cdn1.shooq.co.il/data/crop2/n/' + width + '/' + height + '/' + path;
        case 'r':
        case 'resize':
            return 'https://cdn1.shooq.co.il/data/resize/f/' + width + '/' + height + '/' + path;
        default:
            return 'https://cdn1.shooq.co.il/data/crop2/n/' + width + '/' + height + '/' + path;
    }

};

